// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fRCCK","index":"styles_index__2gQmr"};